var React = require('react');

function Home (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19 21H5C4.44771 21 4 20.5523 4 20V10.6809C4 10.4126 4.1078 10.1556 4.29918 9.96758L11.2992 3.09039C11.6882 2.70817 12.3118 2.70817 12.7008 3.09039L19.7008 9.96758C19.8922 10.1556 20 10.4126 20 10.6809V20C20 20.5523 19.5523 21 19 21Z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("circle",{"cx":"12","cy":"14","r":"2","fill":"currentColor","key":1})]);
}

Home.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Home;

Home.default = Home;
